"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _I18n = _interopRequireDefault(require("I18n"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _UIIcon = _interopRequireDefault(require("UIComponents/icon/UIIcon"));

var _UIPopover = _interopRequireDefault(require("UIComponents/tooltip/UIPopover"));

var _UISelect = _interopRequireDefault(require("UIComponents/input/UISelect"));

var _UIFormControl = _interopRequireDefault(require("UIComponents/form/UIFormControl"));

var _ContactProperties = require("lead-flows-ui/constants/ContactProperties");

var ContactPropertyOptionPresetsForSelect = Object.values(_ContactProperties.ContactPropertyOptionPresets || {}).map(function (optionPreset) {
  return {
    value: optionPreset.label
  };
});

var ContactPropertyOptionsPresets =
/*#__PURE__*/
function (_React$PureComponent) {
  (0, _inherits2.default)(ContactPropertyOptionsPresets, _React$PureComponent);
  (0, _createClass2.default)(ContactPropertyOptionsPresets, [{
    key: "getLangKey",
    value: function getLangKey(path) {
      return "leadFlowEditor.contactProperties.createNew." + path;
    }
  }], [{
    key: "propTypes",
    get: function get() {
      return {
        handleUpdateOptions: _react.default.PropTypes.func.isRequired,
        options: _react.default.PropTypes.array.isRequired
      };
    }
  }]);

  function ContactPropertyOptionsPresets() {
    var _this;

    (0, _classCallCheck2.default)(this, ContactPropertyOptionsPresets);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ContactPropertyOptionsPresets).call(this));
    _this.state = {
      isModalOpened: false,
      presetOptions: null
    };
    _this.handleButtonClick = _this.handleButtonClick.bind((0, _assertThisInitialized2.default)(_this));
    _this.handlePresetChange = _this.handlePresetChange.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleModalConfirm = _this.handleModalConfirm.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleModalReject = _this.handleModalReject.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(ContactPropertyOptionsPresets, [{
    key: "handleButtonClick",
    value: function handleButtonClick() {
      this.setState({
        isModalOpened: !this.state.isModalOpened
      });
    }
  }, {
    key: "handlePresetChange",
    value: function handlePresetChange(_ref) {
      var value = _ref.target.value;
      this.setState({
        presetOptions: value
      });
    }
  }, {
    key: "handleModalConfirm",
    value: function handleModalConfirm() {
      var presetData = _ContactProperties.ContactPropertyOptionPresets[this.state.presetOptions].options;
      this.props.handleUpdateOptions(presetData);
      this.setState({
        isModalOpened: false
      });
    }
  }, {
    key: "handleModalReject",
    value: function handleModalReject() {
      this.setState({
        isModalOpened: false
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
          isModalOpened = _this$state.isModalOpened,
          presetOptions = _this$state.presetOptions;
      return _react.default.createElement(_UIPopover.default, {
        placement: "top",
        open: isModalOpened,
        content: {
          header: _react.default.createElement("h4", null, _react.default.createElement(_FormattedMessage.default, {
            message: this.getLangKey('presets.header')
          })),
          body: _react.default.createElement(_UIFormControl.default, {
            label: "Options"
          }, _react.default.createElement(_UISelect.default, {
            className: "m-bottom-4",
            onChange: this.handlePresetChange,
            options: ContactPropertyOptionPresetsForSelect,
            placeholder: _I18n.default.text(this.getLangKey('presets.placeholder')),
            value: presetOptions
          })),
          footer: _react.default.createElement("div", null, _react.default.createElement(_UIButton.default, {
            use: "primary",
            onClick: this.handleModalConfirm
          }, _react.default.createElement(_FormattedMessage.default, {
            message: this.getLangKey('presets.load')
          })), _react.default.createElement(_UIButton.default, {
            onClick: this.handleModalReject
          }, _react.default.createElement(_FormattedMessage.default, {
            message: this.getLangKey('cancel')
          })))
        }
      }, _react.default.createElement(_UIButton.default, {
        onClick: this.handleButtonClick,
        use: "link",
        className: "m-right-5"
      }, _react.default.createElement(_UIIcon.default, {
        className: "m-right-1",
        name: "listView"
      }), _react.default.createElement(_FormattedMessage.default, {
        message: this.getLangKey('presets.load')
      })));
    }
  }]);
  return ContactPropertyOptionsPresets;
}(_react.default.PureComponent);

exports.default = ContactPropertyOptionsPresets;
module.exports = exports.default;